













































import {
  defineComponent,
  watch,
} from '@vue/composition-api';
import { Popup } from '@hb/coffee';
import { ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { useRealityMaxQuotaFormatted, useIsRealityQuotaExperimental } from '@/shared/utils/getMaxQuota';
import { reportPopupExposure } from '@/api/popup';
import { PopupIdEnum } from '@/api/popup/types';
import { ubtSendError } from '@/shared/utils/ubt';
import type { PropType } from '@vue/composition-api';

export default defineComponent({
  components: {
    Popup,
  },
  props: {
    // 控制弹窗显示状态
    show: {
      type: Boolean,
      required: true,
    },
    // 是否需要补充资料(是否差一步)
    needSupplement: {
      type: Boolean,
      required: true,
    },
    // 退出挽留弹窗ID
    popupId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  emits: ['confirm', 'cancel', 'close'],
  setup(
    props: {
      show: boolean;
      needSupplement: boolean;
      popupId: PopupIdEnum;
    },
    context: {
      emit: (event: 'confirm' | 'cancel' | 'close') => void;
    },
  ) {
    const maxQuotaFormatted = useRealityMaxQuotaFormatted();
    const isRealityQuotaExp = useIsRealityQuotaExperimental();

    const getUbtParams = () => ({
      loaded: 1, // 表示协议加载完成后的弹窗
      isExperimental: isRealityQuotaExp.value, // 表示实验性弹窗
      popupId: props.popupId, // 退出挽留弹窗ID
    });

    // 继续借款按钮点击处理
    const handleConfirm = () => {
      context.emit('confirm');
      ubtSetupPageButton(
        'finance_loan_preApplyChoose_backPop_continue',
        getUbtParams(),
      );
    };

    // 确认不要了按钮点击处理
    const handleCancel = () => {
      context.emit('cancel');
      ubtSetupPageButton(
        'finance_loan_preApplyChoose_backPop_back',
        getUbtParams(),
      );
    };

    // 关闭按钮点击处理
    const handleClose = () => {
      context.emit('close');
      ubtSetupPageButton(
        'finance_loan_preApplyChoose_backPop_close',
        getUbtParams(),
      );
    };

    /** 监听 show 变化，当弹窗展示时上报曝光次数+1 */
    watch(
      () => props.show,
      (visible) => {
        if (visible) {
          reportPopupExposure(props.popupId, Date.now())
            .catch((error) => ubtSendError({
              name: `reportPopupExposure-error-${props.popupId}`,
              message: (error as Error).message,
            }));
        }
      },
    );

    return {
      maxQuotaFormatted,
      isRealityQuotaExp,
      handleConfirm,
      handleCancel,
      handleClose,
    };
  },
});
